import React, { Component } from 'react';
import Flipper from '../Flipper'

class componentName extends Component {
	constructor(props) {
		super(props)

		this.state = {
			currentValue: this.getCurrentValue(this.props.value),
			value: this.isEven(this.props.value) ? this.props.value : (this.props.value - 1),
		}
	}

	getCurrentValue(val) {
		return this.isEven(val) ? 0 :  1
	}

	isEven(number) {
		return (number % 2 === 0)
	}

	componentDidMount() {
		this.runAnimation()
	}

	componentWillReceiveProps(nextProps) {
		this.setState({
			value: nextProps.value
		})

		this.clear()
		this.runAnimation()
	}

	clear() {
		this.setState({
			currentValue: this.getCurrentValue(this.props.value)
		})
	}

	runAnimation() {
		this.interval = setInterval(() => {
			if (this.state.currentValue < this.state.value) {
				const newValue = this.state.currentValue + (this.state.value / 100)
				
				this.setState({
					currentValue: newValue
				})
			} else {
				clearInterval(this.interval)
				delete (this.interval)
			}
		}, 30)
	}

	getNumbers() {
		let numbers = []
		const length = this.state.value.toString().length
		let stringArray = this.state.currentValue.toString().split('')
		const lengthDiff = length - stringArray.length

		for (let i = 0; i < lengthDiff; i++) {
			stringArray.unshift('0')
		}

		const currentValue = stringArray.join('')

		for (let i = 0; i < length; i++) {

			const newNumber = parseInt(currentValue.charAt(i), 10)

			numbers.push(
				<Flipper key={`Flipper${i}`} now={newNumber} />
			)
		}

		return numbers
	}

	render() {

		return (
			<div className={'FlipCounterWrapper'}>
				{this.getNumbers()}
			</div>
		);
	}
}

export default componentName;


// WEBPACK FOOTER //
// ./src/Components/FlipCounter/index.js